import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { RECOVER_USERNAME_REQUEST } from "../types/RequestTypes";
import { showToast } from "../../../utils/ToastEmitter";
import extractErrorMessage from "../../../helpers/extractErrorMessage";

async function recoverUsername(req: RECOVER_USERNAME_REQUEST) {
  return fetcher({
    url: "users/recover/username",
    method: "POST",
    data: req,
    authRequired: false,
  });
}

export default function useRecoverUsernameMutation(cb?: () => void) {
  return useMutation({
    mutationFn: recoverUsername,
    onSuccess: () => {
      cb?.();
    },
    onError: (err: any) => {
      showToast(extractErrorMessage(err), "error");
    },
  });
}
